<template>
  <div class="card">
    <Toast />
    <div class="title">Daftar Pelanggan</div>

    <Toolbar class="p-mb-2">
      <template slot="left">
        <Button
          label="Tambah"
          icon="pi pi-plus"
          class="p-button-success"
          @click="createCustomer()"
        />
      </template>
      <template slot="right"> </template>
    </Toolbar>

    <DataTable
      :value="customers"
      :lazy="true"
      :paginator="true"
      :rows="limit"
      :totalRecords="total_records"
      :loading="loading.filter"
      @page="getCustomers($event)"
    >
      <template #header>
        <div class="p-grid p-fluid p-mb-2">
          <div class="p-col-12 p-md-6 p-lg-6">
            <label for="">Nama</label> <br />
            <InputText v-model="filter.name" placeholder="Nama" />
          </div>
          <div class="p-col-12 p-md-6 p-lg-6">
            <label for="">Tipe</label> <br />
            <InputText v-model="filter.type" placeholder="Tipe" />
          </div>
        </div>

        <div class="p-grid p-fluid p-justify-center">
          <div class="p-col-12 p-md-4 p-lg-4">
            <Button
              label="Cari"
              class="p-button-info"
              @click="getCustomers()"
            />
          </div>
        </div>
      </template>

      <template #empty>Data tidak ada</template>
      <template #loading>Loading ...</template>

      <Column field="name" header="Nama">
        <template #body="slotProps">
          {{ slotProps.data.name }}
        </template>
      </Column>
      <Column field="email" header="Email">
        <template #body="slotProps">
          {{ slotProps.data.email }}
        </template>
      </Column>
      <Column field="phone" header="Telepon">
        <template #body="slotProps">
          {{ slotProps.data.phone }}
        </template>
      </Column>
      <Column field="points" header="Poin">
        <template #body="slotProps">
          {{ slotProps.data.points }}
        </template>
      </Column>
      <Column field="type" header="Tipe">
        <template #body="slotProps">
          {{ slotProps.data.type }}
        </template>
      </Column>

      <Column v-if="user.role == 'OUTLET_MANAGER'">
        <template #body="slotProps">
          <Button
            icon="pi pi-pencil"
            class="p-button-rounded p-button-success p-mr-2"
            @click="editCustomer(slotProps.data)"
          />
          <Button
            icon="pi pi-times"
            class="p-button-rounded p-button-warning"
            @click="deactivateCustomer(slotProps.data)"
          />
        </template>
      </Column>
    </DataTable>

    <Dialog
      :visible.sync="create_dialog"
      :style="{ width: '450px' }"
      header="Tambah Pelanggan"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-field">
        <label for="">Tipe</label>
        <Dropdown
          v-model="selected_type"
          :options="types"
          optionLabel="type"
          placeholder="Pilih tipe"
          @change="is_error.type = false"
        />
        <small class="p-error" v-if="is_error.type">{{ error_msg.type }}</small>
      </div>
      <div class="p-field">
        <label for="">Nama</label>
        <InputText
          v-model="create_data.name"
          placeholder="Nama"
          @keyup.prevent="is_error.name = false"
        />
        <small class="p-error" v-if="is_error.name">{{ error_msg.name }}</small>
      </div>
      <div class="p-field">
        <label for="">Email</label>
        <InputText
          v-model="create_data.email"
          placeholder="Email"
          @keyup.prevent="is_error.email = false"
        />
        <small class="p-error" v-if="is_error.email">{{
          error_msg.email
        }}</small>
      </div>
      <div class="p-field">
        <label for="">Telepon</label>
        <InputText
          type="number"
          required
          v-model="create_data.phone"
          placeholder="Telepon"
          @keyup.prevent="is_error.phone = false"
        />
        <small class="p-error" v-if="is_error.phone">{{
          error_msg.phone
        }}</small>
      </div>

      <template #footer>
        <Button
          label="Batal"
          class="p-button-outlined"
          @click="create_dialog = false"
        />
        <Button label="Tambah" class="p-button-info" @click="postCustomer" />
      </template>
    </Dialog>

    <Dialog
      :visible.sync="edit_dialog"
      :style="{ width: '450px' }"
      header="Edit Pelanggan"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-field">
        <label for="">Tipe</label>
        <Dropdown
          v-model="selected_type"
          :options="types"
          optionLabel="type"
          placeholder="Pilih tipe"
          @change="is_error.type = false"
        />
        <small class="p-error" v-if="is_error.type">{{ error_msg.type }}</small>
      </div>
      <div class="p-field">
        <label for="">Nama</label>
        <InputText
          v-model="edit_data.name"
          placeholder="Nama"
          @keyup.prevent="is_error.name = false"
        />
        <small class="p-error" v-if="is_error.name">{{ error_msg.name }}</small>
      </div>
      <div class="p-field">
        <label for="">Email</label>
        <InputText v-model="edit_data.email" :disabled="true" />
      </div>
      <div class="p-field">
        <label for="">Telepon</label>
        <InputText v-model="edit_data.phone" :disabled="true" />
      </div>
      <div class="p-field">
        <label for="">Points</label>
        <InputText v-model="edit_data.points" :disabled="true" />
      </div>

      <template #footer>
        <Button
          label="Batal"
          icon="pi pi-times"
          class="p-button-outlined"
          @click="edit_dialog = false"
        />
        <Button label="Simpan" class="p-button-info" @click="putCustomer()" />
      </template>
    </Dialog>

    <Dialog
      :visible.sync="deactivate_dialog"
      :style="{ width: '450px' }"
      header="Konfirmasi Deactivate"
      :modal="true"
    >
      <div class="confirmation-content">
        Apakah kamu yakin ingin men-deactivate
        <b>{{ deactivate_data.name }}</b
        >?
      </div>
      <template #footer>
        <Button
          label="Tidak"
          icon="pi pi-times"
          class="p-button-text"
          @click="deactivate_dialog = false"
        />
        <Button
          label="Ya"
          icon="pi pi-check"
          class="p-button-text"
          @click="patchCustomerDeactivate()"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      create_dialog: false,
      edit_dialog: false,
      deactivate_dialog: false,

      loading: {
        filter: false,
        create: false,
        edit: false,
        deactivate: false
      },

      types: [{ type: 'REGULAR' }, { type: 'RESELLER' }],
      selected_type: null,

      customers: [],
      filter: {
        name: '',
        type: ''
      },

      create_data: {
        name: '',
        email: '',
        phone: '',
        type: ''
      },
      edit_data: {},
      deactivate_data: {},

      is_error: {
        name: false,
        email: false,
        phone: false,
        type: false
      },
      error_msg: {
        name: '',
        email: '',
        phone: '',
        type: ''
      },

      limit: 5,
      total_records: 0
    }
  },
  computed: mapState(['user', 'isAuthenticated']),
  mounted() {
    this.getCustomers()
  },
  methods: {
    getCustomers(event) {
      let page = 1
      if (event) {
        page = event.page + 1
      }

      this.loading.filter = true
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/customers?page=${page}&limit=${this.limit}&name=${this.filter.name}&type=${this.filter.type}`
        )
        .then(response => {
          this.loading.filter = false
          if (response.status === 200) {
            this.customers = response.data.data.customers
            this.total_records = response.data.data.total
          }
        })
    },

    createCustomer() {
      this.create_dialog = true
      this.create_data.name = ''
      this.create_data.email = ''
      this.create_data.phone = ''
      this.create_data.type = ''
      this.is_error.name = false
      this.is_error.email = false
      this.is_error.phone = false
      this.is_error.type = false
    },

    async postCustomer() {
      if (this.create_data.email === '') {
        this.is_error.email = true
        this.error_msg.email = 'Mohon isi email'
      }
      if (this.create_data.name === '') {
        this.is_error.name = true
        this.error_msg.name = 'Mohon isi nama'
      }
      if (this.create_data.phone === '') {
        this.is_error.phone = true
        this.error_msg.phone = 'Mohon isi telepon'
      }

      if (this.selected_type === null) {
        this.is_error.type = true
        this.error_msg.type = 'Mohon pilih tipe'
      } else {
        this.create_data.type = this.selected_type.type
      }

      this.loading.create = true
      if (
        !this.is_error.name &&
        !this.is_error.email &&
        !this.is_error.type &&
        !this.is_error.phone
      ) {
        try {
          const response = await this.$http.post(
            `${process.env.VUE_APP_API_URL}/customers`,
            this.create_data
          )

          this.loading.create = false

          if (response.status === 200) {
            this.create_dialog = false
            this.getCustomers()

            this.selected_type = null
            this.create_data.name = ''
            this.create_data.email = ''
            this.create_data.phone = ''
            this.create_data.type = ''

            this.showToast('success', 'Berhasil menambahkan pelanggan')
          } else {
            this.showToast('error', 'Gagal menambahkan pelanggan')
          }
        } catch (error) {
          this.loading.create = false
          console.error('Error adding customer:', error)
          this.showToast(
            'error',
            'Gagal menambahkan pelanggan',
            'Terjadi kesalahan saat menambahkan pelanggan'
          )
        }
      }
    },

    editCustomer(customer) {
      Object.assign(this.edit_data, customer)
      this.selected_type = { type: this.edit_data.type }
      this.edit_dialog = true
      this.is_error.type = false
      this.is_error.name = false
    },

    async putCustomer() {
      this.edit_data.type = this.selected_type.type

      if (this.edit_data.name === '') {
        this.is_error.name = true
        this.error_msg.name = 'Mohon isi nama'
      }
      if (this.edit_data.type === '') {
        this.is_error.type = true
        this.error_msg.type = 'Mohon pilih tipe'
      }

      this.loading.edit = true
      if (!this.is_error.type && !this.is_error.name) {
        try {
          const response = await this.$http.put(
            `${process.env.VUE_APP_API_URL}/customers/${this.edit_data.id}`,
            this.edit_data
          )

          this.loading.edit = false

          if (response.status === 200) {
            this.edit_dialog = false
            this.getCustomers()
            this.showToast('success', 'Berhasil edit pelanggan')
          } else {
            this.showToast('error', 'Gagal edit pelanggan')
          }
        } catch (error) {
          this.loading.edit = false
          console.error('Error editing customer:', error)
          this.showToast(
            'error',
            'Gagal edit pelanggan',
            'Terjadi kesalahan saat mengedit pelanggan'
          )
        }
      }
    },

    deactivateCustomer(customer) {
      Object.assign(this.deactivate_data, customer)
      this.deactivate_dialog = true
    },

    async patchCustomerDeactivate() {
      this.loading.deactivate = true

      try {
        const response = await this.$http.patch(
          `${process.env.VUE_APP_API_URL}/customers/${this.deactivate_data.id}/deactivate`
        )

        this.loading.deactivate = false
        this.deactivate_dialog = false

        if (response.status === 200) {
          this.getCustomers()
          this.showToast('success', 'Berhasil Deactivate Pelanggan')
        } else {
          this.showToast('error', 'Gagal Deactivate Pelanggan')
        }
      } catch (error) {
        this.loading.deactivate = false
        console.error('Error deactivating customer:', error)
        this.showToast(
          'error',
          'Gagal Deactivate Pelanggan',
          'Terjadi kesalahan saat melakukan deactivate pelanggan'
        )
      }
    }
  }
}
</script>

<style scoped lang="scss">
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

::v-deep(.p-datatable table) {
  border-collapse: collapse;
}

::v-deep(.p-datatable th),
::v-deep(.p-datatable td) {
  border: 1px solid #ccc !important;
  padding: 8px;
}
</style>
